var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaceswapakool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 2000,
    viewBox: "0 0 1440 2000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1150_2947",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 2000
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2000,
    fill: "url(#paint0_linear_1150_2947)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1150_2947)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 774,
    cy: 1314,
    r: 400,
    fill: "url(#paint1_radial_1150_2947)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 361,
    r: 400,
    fill: "url(#paint2_radial_1150_2947)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 851.5,
    y: -1.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 851.5,
    y: 157.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 851.5,
    y: 316.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 692.5,
    y: -1.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 533.5,
    y: -1.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 692.5,
    y: 157.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 533.5,
    y: 157.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 692.5,
    y: 316.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 533.5,
    y: 316.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1010.5,
    y: -1.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1010.5,
    y: 157.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1010.5,
    y: 316.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1169.5,
    y: -1.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1328.5,
    y: -1.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1328.5,
    y: 157.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1328.5,
    y: 316.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1169.5,
    y: 157.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1169.5,
    y: 316.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 847,
    y: 157,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 852,
    y: 153,
    width: 9,
    height: 1,
    transform: "rotate(90 852 153)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006,
    y: 157,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1011,
    y: 153,
    width: 9,
    height: 1,
    transform: "rotate(90 1011 153)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1165,
    y: 157,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170,
    y: 153,
    width: 9,
    height: 1,
    transform: "rotate(90 1170 153)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 157,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1329,
    y: 153,
    width: 9,
    height: 1,
    transform: "rotate(90 1329 153)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 688,
    y: 157,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 693,
    y: 153,
    width: 9,
    height: 1,
    transform: "rotate(90 693 153)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529,
    y: 157,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534,
    y: 153,
    width: 9,
    height: 1,
    transform: "rotate(90 534 153)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 852,
    y: -6,
    width: 9,
    height: 1,
    transform: "rotate(90 852 -6)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1011,
    y: -6,
    width: 9,
    height: 1,
    transform: "rotate(90 1011 -6)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170,
    y: -6,
    width: 9,
    height: 1,
    transform: "rotate(90 1170 -6)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1329,
    y: -6,
    width: 9,
    height: 1,
    transform: "rotate(90 1329 -6)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 693,
    y: -6,
    width: 9,
    height: 1,
    transform: "rotate(90 693 -6)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534,
    y: -6,
    width: 9,
    height: 1,
    transform: "rotate(90 534 -6)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 847,
    y: 316,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 852,
    y: 312,
    width: 9,
    height: 1,
    transform: "rotate(90 852 312)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006,
    y: 316,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1011,
    y: 312,
    width: 9,
    height: 1,
    transform: "rotate(90 1011 312)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1165,
    y: 316,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170,
    y: 312,
    width: 9,
    height: 1,
    transform: "rotate(90 1170 312)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 316,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1329,
    y: 312,
    width: 9,
    height: 1,
    transform: "rotate(90 1329 312)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 688,
    y: 316,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 693,
    y: 312,
    width: 9,
    height: 1,
    transform: "rotate(90 693 312)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529,
    y: 316,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534,
    y: 312,
    width: 9,
    height: 1,
    transform: "rotate(90 534 312)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 847,
    y: 475,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 852,
    y: 471,
    width: 9,
    height: 1,
    transform: "rotate(90 852 471)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006,
    y: 475,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1011,
    y: 471,
    width: 9,
    height: 1,
    transform: "rotate(90 1011 471)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1165,
    y: 475,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170,
    y: 471,
    width: 9,
    height: 1,
    transform: "rotate(90 1170 471)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1324,
    y: 475,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1329,
    y: 471,
    width: 9,
    height: 1,
    transform: "rotate(90 1329 471)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 688,
    y: 475,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 693,
    y: 471,
    width: 9,
    height: 1,
    transform: "rotate(90 693 471)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529,
    y: 475,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534,
    y: 471,
    width: 9,
    height: 1,
    transform: "rotate(90 534 471)",
    fill: "#999999"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1237.5,
    y: 1515.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1237.5,
    y: 1674.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1237.5,
    y: 1833.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.5,
    y: 1515.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.5,
    y: 1515.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.5,
    y: 1674.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.5,
    y: 1674.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.5,
    y: 1833.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.5,
    y: 1833.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1396.5,
    y: 1515.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1396.5,
    y: 1674.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1396.5,
    y: 1833.5,
    width: 159,
    height: 159,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1233,
    y: 1674,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1238,
    y: 1670,
    width: 9,
    height: 1,
    transform: "rotate(90 1238 1670)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1392,
    y: 1674,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1397,
    y: 1670,
    width: 9,
    height: 1,
    transform: "rotate(90 1397 1670)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1074,
    y: 1674,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 1670,
    width: 9,
    height: 1,
    transform: "rotate(90 1079 1670)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915,
    y: 1674,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 1670,
    width: 9,
    height: 1,
    transform: "rotate(90 920 1670)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1233,
    y: 1515,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1238,
    y: 1511,
    width: 9,
    height: 1,
    transform: "rotate(90 1238 1511)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1392,
    y: 1515,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1397,
    y: 1511,
    width: 9,
    height: 1,
    transform: "rotate(90 1397 1511)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1074,
    y: 1515,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 1511,
    width: 9,
    height: 1,
    transform: "rotate(90 1079 1511)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915,
    y: 1515,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 1511,
    width: 9,
    height: 1,
    transform: "rotate(90 920 1511)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1233,
    y: 1833,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1238,
    y: 1829,
    width: 9,
    height: 1,
    transform: "rotate(90 1238 1829)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1392,
    y: 1833,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1397,
    y: 1829,
    width: 9,
    height: 1,
    transform: "rotate(90 1397 1829)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1074,
    y: 1833,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 1829,
    width: 9,
    height: 1,
    transform: "rotate(90 1079 1829)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915,
    y: 1833,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 1829,
    width: 9,
    height: 1,
    transform: "rotate(90 920 1829)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1233,
    y: 1992,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1238,
    y: 1988,
    width: 9,
    height: 1,
    transform: "rotate(90 1238 1988)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1392,
    y: 1992,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1397,
    y: 1988,
    width: 9,
    height: 1,
    transform: "rotate(90 1397 1988)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1074,
    y: 1992,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1079,
    y: 1988,
    width: 9,
    height: 1,
    transform: "rotate(90 1079 1988)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915,
    y: 1992,
    width: 9,
    height: 1,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 920,
    y: 1988,
    width: 9,
    height: 1,
    transform: "rotate(90 920 1988)",
    fill: "#999999"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M253.714 615.641L-2.43112 -105.5H-115.792L140.353 615.641H253.714Z",
    stroke: "#6A00FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-495.304 1146.64L-239.141 384.5H54.6728L-201.491 1146.64H-495.304Z",
    stroke: "#6A00FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.258 0H696.5L440 806H243.758L500.258 0Z",
    fill: "url(#paint3_linear_1150_2947)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1150_2947",
    x1: 0,
    y1: 331.166,
    x2: 34.5625,
    y2: 331.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1150_2947",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(774 1314) rotate(90) scale(390.815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B0B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1150_2947",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(329 361) rotate(90) scale(390.815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B0B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1150_2947",
    x1: 155.005,
    y1: 543.068,
    x2: 534.306,
    y2: 610.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A00FC",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A00FC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceswapakool);
export default __webpack_public_path__ + "static/media/faceswap.akool.4c76315a5bcf59f98641355d938d624e.svg";
export { ForwardRef as ReactComponent };